export { default as thunkMiddleware } from './thunk'
export { default as loggerMiddleware } from './logger'



/** WEBPACK FOOTER **
 ** ./lib/middleware/index.js
 **/